
import md5 from 'md5';
import empty from './empty';

export default {
  appAuth: {
    watch: {
      $route (to, from) {
        if (from.name === 'login') {
          if (this.getLocal('adminStatus') === '1') {
            this.menuList = this.$store.state.menuList;
          } else {
            localStorage.menuList && (this.menuList = this.getLocal('menuList'));
          }
        }
      }
    },
    created () {
      this.initMenuRoute();
    },
    methods: {
      initMenuRoute () {
        if (this.getLocal('adminStatus') === '1') {
          let state = this.$store.state;
          this.menuList = state.menuList;
          this.$router.addRoutes(state.routes);
        } else {
          this.setMenuRoute();
        }
      },
      setMenuRoute (menuList, routeList) {
        let state = this.$store.state;
        if (menuList && routeList) {
          routeList.push(state.noPageRoute);
          this.$router.addRoutes(routeList);
        } else {
          localStorage.menuList && (this.menuList = this.getLocal('menuList'));
          let routes = this.getLocal('routeList');
          if (routes) {
            routes.forEach((el) => {
              state.routes.forEach((item) => {
                if (item.name === el.name) {
                  el.component = item.component;
                }
              });
            });
            routes.push(state.noPageRoute);
            this.$router.addRoutes(routes);
          }
        }
      }
    }
  },
  tableAuth: {
    created () {
      this.disableAllBtn();
      if (this.getLocal('adminStatus') === '1') {
        this.openBtnAuth();
      } else {
        this.setBtnAuth();
      }
    },
    methods: {
      /* 禁用全部权限按钮 */
      disableAllBtn () {
        this.tableOptList.forEach((item) => {
          item.authDisabled = true;
        });

        this.rowOptList.forEach((part) => {
          if (Array.isArray(part)) {
            part.forEach((el) => {
              el.authDisabled = true;
            });
          } else {
            part.authDisabled = true;
          }
        });
      },
      /* 放开按钮权限 */
      openBtnAuth () {
        this.tableOptList.forEach((item) => {
          item.authDisabled = false;
        });
        this.rowOptList.forEach((part) => {
          if (Array.isArray(part)) {
            part.forEach((el) => {
              el.authDisabled = false;
            });
          } else {
            part.authDisabled = false;
          }
        });
      },
      /* 设置按钮权限 */
      setBtnAuth () {
        let btnList = this.getLocal('btnList');
        btnList && btnList.forEach((el) => {
          if (this.$route.name === el.componentName) {
            this.tableOptList.forEach((item) => {
              if (item.key === el.key) {
                item.authDisabled = false;
              }
            });

            this.rowOptList.forEach((part) => {
              if (Array.isArray(part)) {
                part.forEach((eve) => {
                  if (eve.key === el.key) {
                    eve.authDisabled = false;
                  }
                });
              } else {
                if (part.key === el.key) {
                  part.authDisabled = false;
                }
              }
            });
          }
        });
        console.log('set.tableOptList: ', this.tableOptList);
        console.log('set.rowOptList: ', this.rowOptList);
      }
    }
  },
  addEditAuth: {
    data () {
      return { submitDisabled: true };
    },
    created () {
      this.$route.name === 'userInfo' && (this.submitDisabled = false);

      if (this.getLocal('adminStatus') === '1') {
        this.submitDisabled = false;
      } else {
        this.pageBtnAuth();
      }
    },
    methods: {
      /* 设置按钮权限 */
      pageBtnAuth () {
        let btnList = this.getLocal('btnList');
        btnList && btnList.forEach((el) => {
          if (this.$route.name === el.componentName) {
            el.key === 'submit' && (this.submitDisabled = false);
          }
        });
      }
    }
  },
  toolBarAuth: {
    created () {
      this.disableAllBar();
      if (this.getLocal('adminStatus') === '1') {
        this.openToolbarAuth();
      } else {
        this.setToolbarAuth();
      }
    },
    methods: {
      /* 禁用所有toolbar */
      disableAllBar () {
        this.toolBarList.forEach((item) => {
          item.authDisabled = true;
        });
      },
      /* 放开按钮权限 */
      openToolbarAuth () {
        this.toolBarList.forEach((item) => {
          item.authDisabled = false;
        });
      },
      /* 设置按钮权限 */
      setToolbarAuth () {
        let btnList = this.getLocal('btnList');
        btnList && btnList.forEach((el) => {
          if (this.$route.name === el.componentName) {
            this.toolBarList.forEach((item) => {
              item.key === el.key && (item.authDisabled = false);
            });
          }
        });
        console.log('set.toolBarList: ', this.toolBarList);
      }
    }
  },
  importRoomAuth: {
    methods: {
      btnAuth () {
        let btnList = this.getLocal('btnList');
        btnList && btnList.forEach((el) => {
          if (this.$route.name === el.componentName) {
            el.key === 'download' && (this.disableDown = false);
          }
        });
      }
    }
  },

  upload: {
    data () {
      return {
        fileData: '',
        upLoading: { loading: false }
      };
    },
    methods: {
      /* 上传前钩子 */
      beforeUpload (file, fileList, key) {
        console.log('file: ', file);
        this.fileData = file;

        let index = this.gainListIndex(this.formList, key);
        let upload = this.formList[index];
        upload && upload.beforeHandle && upload.beforeHandle(file, fileList);
        return true;
      },
      /* 自定义上传事件 */
      customRequest (e, name) {
        let formdata = new FormData();
        formdata.append('file', this.fileData);
        this.$post({
          url: this.$store.state.uploadUrl,
          params: formdata,
          btnLoading: this.upLoading,
          config: { timeout: 200000 }
        }).then(({data}) => {
          let file = e.file;
          let fileObj = { [name]: data.file_id };
          this.formList.forEach((el) => {
            if (el.inputType === 'upload' && el.name === name) {
              el.fileList = [{
                uid: file.uid,
                name: file.name,
                url: data.file_url
              }];
            }
          });
          this.fieldData = {...this.fieldData, ...fileObj};
        }).catch(() => { // 上传失败清除文件
          this.form.resetFields([name]);
        });
      }
    }
  },
  inputSearch: {
    methods: {
      /* select搜索下拉项 */
      filterOption (input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) > -1;
      },
      /* 级联搜索下拉项 */
      filter (inputValue, path) {
        return (path.some(option => (option.label || option.title).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
      },
      /* 穿梭框搜索 */
      transferFilter (inputValue, option) {
        return option.title.toLowerCase().indexOf(inputValue) > -1;
      },
      /**
       * 选项在两栏之间转移时的回调函数
       * @param nextTargetKeys 事件后目标数据中有的key
       * @param direction 左移或右移操作
       * @param moveKeys 要移动的key
       */
      handleChange (nextTargetKeys, direction, moveKeys) {
        this.targetKeys = nextTargetKeys;
      }
    }
  },
  roleList: {
    methods: {
      /**
       * 一级：主菜单，
       * 二级：二级菜单，
       * 三级：二级菜单对应新增、修改页面，
       * 四级：对应的页面按钮

       * 第一层{title: 主菜单，key: 主菜单key}
       * 二层： {title: 二级菜单，key: 组件名}
       * 三层:{title: 路由字符名, key: route_组件名}
       * 四层：{title: 路由btnlist title, key: 路径_btnlist key}
       * @returns {Array}
       */
      createViewTree () {
        let menuType = {
          manageViewAuth: this.$store.state.menuList,
          propertyViewAuth: this.$store.state.propertyMenu,
          govViewAuth: this.$store.state.govMenu
        };
        let menuArr = [];
        menuType[this.$route.name].forEach((el) => { // el 每一个主菜单
          let children = [];
          el.subMenu && el.subMenu.forEach((item) => { // item 每一个二级菜单
            children.push({
              title: item.title,
              // key: md5(item.route)
              key: item.route // 为二级菜单页面的路由name
            });
          });
          menuArr.push({
            title: el.title,
            // key: md5(el.key),
            key: el.key,
            children: children
          });
        });

        let routeArr = this.handlePropertyRoute();
        let routeType = {
          manageViewAuth: this.$store.state.routes,
          propertyViewAuth: routeArr,
          govViewAuth: this.$store.state.govRoutes
        };
        menuArr.forEach((el) => {
          el.children && el.children.forEach((part) => { // part 每一个二级菜单
            let arr = [];
            routeType[this.$route.name].forEach((item) => { // item 每一个路由
              let btnArr = [];
              item.btnList && item.btnList.forEach((eve) => { // eve 页面上每一个按钮
                btnArr.push({
                  title: eve.title,
                  // key: md5(`${item.path}${eve.key}`)
                  key: `${item.path}_${eve.key}`
                });
              });

              // let menuKey = item.menuKey && md5(item.menuKey);
              let menuKey = item.menuKey;
              if (menuKey && menuKey === part.key) { // 如果item.menuKey(路由的menuKey)和part.key(就是二级菜单主页面的路由name)
                arr.push({
                  title: item.meta.title,
                  // key: md5(item.name),
                  key: `route_${item.name}`,
                  children: btnArr
                });
              }
            });
            part.children = arr;
          });
        });

        this.treeData && (this.treeData = menuArr);
        this.getAllValue(menuArr);
        return menuArr;
      },

      /* 处理物业路由(展平children项) */
      handlePropertyRoute () {
        let arr = [];
        if (this.$route.name === 'propertyViewAuth') {
          this.$store.state.propertyRoutes.forEach((el) => {
            arr.push({...el});
            el.children && el.children.forEach((item) => {
              arr.push({...item});
            });
          });
        }
        return arr;
      }
    }
  },
  addEdit: {
    data () {
      return {
        fieldData: {},
        textData: {},
        targetKeys: [],
        selectedKeys: []
      };
    },
    watch: {
      formData (val) {
        if (val) {
          this.$nextTick(() => {
            this.form.setFieldsValue(val);
          });
        }
      }
    },
    created () {
      this.addFormEvent();
      this.formList && this.formList.forEach((el) => {
        el.isShow = true;
      });
    },
    beforeCreate () {
      this.form = this.$form.createForm(this);
    },
    beforeMount () {
      let keyArr = ['city_scope', 'community_scope', 'account_scope'];
      this.formList.forEach((el) => {
        let isSame = keyArr.some(item => item === (el.props && el.props[0]));
        isSame && (el.isShow = false);
      });
    },
    methods: {
      /* 添加表单事件 */
      addFormEvent () {
        empty.$on('setForm', (formVal) => {
          this.$nextTick(() => {
            if (formVal) {
              this.form.setFieldsValue(formVal);
              this.textData = formVal;
              // empty.$off('setForm');
            }
          });
        });
      },
      /* 处理表单项的显隐 */
      handleDynamicForm (e, typeObj) {
        let formKeyObj = typeObj[e];
        this.formList.forEach(el => {
          for (let item in formKeyObj) {
            if (el.key === item) {
              el.isShow = formKeyObj[item];
            }
          }
        });
      },
      /* 清除下级值 */
      resetSubValue (key, val) {
        this.form.resetFields(key);
        this.formList.forEach((el) => {
          Array.isArray(key) && key.forEach((item) => {
            let props = el.props;
            if (props && props[0] === item) {
              el.options = [];
            }
          });
        });
      },
      /* 处理获取详情fileList */
      handleFileList (data) {
        this.formList.forEach((el, index) => {
          if (el.inputType === 'upload') {
            let fileUrl = data[el.resUrl] || data[el.name]; // 返回的url
            if (fileUrl && typeof fileUrl === 'string' && (fileUrl.includes('http') || fileUrl.includes('https'))) {
              let fileName = data[el.resName] || data[el.resUrl] || data[el.name]; // 返回的文件名
              el.fileList = [{uid: index, name: fileName, url: fileUrl}];
            }
          }
        });
      },
      /* 处理时间格式 */
      handleDate (data) {
        let pick = ['rangePick', 'rangeTimePick', 'datePick', 'dateTimePick'];
        let dateValue = {};
        this.formList.forEach((el) => {
          if (pick.some((part) => part === el.inputType)) {
            let prop = el.props && el.props[0];
            if (data[prop]) {
              dateValue = {...dateValue, [prop]: this.Moment(data[prop])};
            }
          }
        });
        return dateValue;
      },
      /* upload 删除文件列表 */
      removeFile (name, e) {
        this.formList.forEach((el, index) => {
          if (el.inputType === 'upload' && el.name === name) {
            let prop = el.props;
            let requireIndex = -1;
            prop &&
            prop[1] &&
            prop[1].hasOwnProperty('rules') &&
            prop[1].rules.length &&
            prop[1].rules.forEach((el, index) => {
              if (el.hasOwnProperty('required')) {
                requireIndex = index;
              }
            });
            if (requireIndex >= 0 && prop[1].rules[requireIndex].required === true) { // 如果为必填，则清空值
              console.log('有 require: ', prop[1].rules[requireIndex]);
              this.form.resetFields([name]);
            } else { // 如果为非必填，直接赋值为0
              this.fieldData[name] = 0;
            }

            el.fileList = [];
          }
        });
      },
      /* 处理弹窗 */
      handleConfirm (param) { // 单独处理编辑app应用
        let isDiff = false;
        for (let item in this.detailValues) {
          if (param.hasOwnProperty(item)) {
            if (item === 'scope') {
              let scope = param[item];
              if (Array.isArray(scope)) {
                param[item] = scope.join(',');
              }
            }
            if (this.detailValues[item] !== param[item]) {
              isDiff = true;
              this.$confirm({
                title: '修改“平台”、“应用范围”将同步到功能配置，确定要修改？',
                centered: true,
                onOk: (close) => {
                  param.if_update = 1;
                  this.editForm(param);
                  close();
                }
              });
              break;
            }
          }
        }
        if (!isDiff) {
          this.editForm(param);
        }
      },
      /* 编辑表单 */
      editForm (values) { // 单独处理编辑app应用
        for (let item in values) {
          if (Array.isArray(values[item])) {
            values[item] = values[item].join(',');
          }
        }
        Object.keys(this.fieldData).length && (values = {...values, ...this.fieldData});
        this.$put({
          url: `${this.editParam.url}${this.routeQuery}`,
          params: values
        }).then((res) => {
          this.$store.commit('setOptData', true);
          this.handleThen('编辑');
        });
      },
      /**
       * 选择项发送变化
       * @param sourceSelectedKeys 源数据选中的key
       * @param targetSelectedKeys 目标数据选中的Key
       */
      transferSelectChange (sourceSelectedKeys, targetSelectedKeys) {
        this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
      },
      /**
       * 选项在两栏之间转移时的回调函数
       * @param nextTargetKeys 事件后目标数据中有的key
       * @param direction 左移或右移操作
       * @param moveKeys 要移动的key
       */
      transferChange (nextTargetKeys, direction, moveKeys) {
        this.targetKeys = nextTargetKeys;
      },

      /* 获取用户范围下拉列表 */
      userRangeList (regionIndex, communityIndex, fn1, fn2) {
        this.regionSelect((data) => {
          this.formList[regionIndex].options = data;
          fn1 && fn1(data); // 需要时可以添加回调
        }, null, '1,2');

        this.communitySelect((data) => {
          let arr = [];
          data.forEach((el) => {
            arr.push({key: `${el.value}`, title: el.label});
          });
          this.formList[communityIndex].options = arr;
          fn2 && fn2(arr); // 需要时可以添加回调
        });
      },
      /* 处理用户范围提交值 */
      rangeReqVal (param) {
        let scopeArr = ['city_scope', 'community_scope', 'account_scope'];
        scopeArr.forEach((el) => {
          for (let item in param) {
            if (el === item) {
              param.scope = param[item];
            }
          }
        });
        typeof param.scope === 'undefined' && (param.scope = '0');
        return param;
      },
      /* 处理用户范围返回值 */
      rangeResVal (values, res) {
        let scopeType = {
          1: 'city_scope',
          2: 'community_scope',
          3: 'account_scope'
        };
        let type = [1, 2].some(el => el === res.scope_type);
        values[scopeType[res.scope_type]] = type ? formatScope() : res.scope;

        function formatScope () {
          let arr = res.scope && res.scope.split(',');
          if (res.scope_type === 1) {
            let cityArr = [];
            arr.forEach((el) => {
              cityArr.push(parseInt(el));
            });
            return cityArr;
          }
          return arr; // formatScope返回
        }

        return values; // 整个函数返回
      },
      /* 处理定时发送单选框 */
      handleDealyTime (value) {
        let index;
        this.formList.forEach((el, i) => {
          let props = el.props;
          if (props && props[0] === 'is_delay') {
            index = i;
          }
        });
        let delayTime = this.formList[index].dateProps[1].rules[0];
        let list = this.formList[index];
        value === 1 ? delayTime.required = true : delayTime.required = false;
        value === 1 ? list.pickerDisabled = false : list.pickerDisabled = true;
        this.$children[0].form.resetFields(['delay_time']);
      },

      /* 定位成功 */
      locaSuccess (val) {
        let obj = {
          'map_lng': val.lng,
          'map_lat': val.lat,
          'address': val.address
        };
        this.$children[0].form.setFieldsValue(obj);
      },
      /* 限制修改上级 */
      limitEdit (res, keyArr) {
        res.can_delete === 0 && this.formList.forEach((el) => {
          keyArr.forEach((item) => {
            if (el.props && el.props[0] === item) {
              el.disabled = true;
            }
          });
        });
      }
    }
  },
  fetchSelect: {
    data () {
      return {
        cascadeParam: {}
      };
    },
    methods: {
      /* 获取省市区 */
      regionSelect (index, scope = 'searchList', type = '1,2,3,4') {
        this.$get({
          url: '/get_area_tree',
          params: { type: type }
        }).then(({data}) => {
          let argument = arguments[0];
          if (argument && typeof argument === 'function') {
            argument(data);
          } else {
            this[scope][index].options = data;
          }
        });
      },
      /* 获取物业下拉 */
      propertySelect (index, scope = 'searchList') {
        this.$get({
          url: '/select_list/property_list',
          params: {}
        }).then(({data}) => {
          this[scope][index].options = data.property_list;
        });
      },
      /* 获取小区下拉 */
      communitySelect (index, scope = 'searchList', isPosition) {
        this.$get({
          url: '/select_list/community_list',
          params: {
            search: '',
            is_show_position: isPosition || 0
          }
        }).then(({data}) => {
          let argument = arguments[0];
          if (argument && typeof argument === 'function') {
            argument(data.community_list);
          } else {
            this[scope][index].options = data.community_list;
          }
        });
      },
      /* 获取楼栋下拉 */
      buildSelect (index, cascadeParam = {}, scope = 'searchList') {
        this.$get({
          url: '/select_list/community_building_list',
          params: {
            community_id: cascadeParam.communityId,
            search: ''
          }
        }).then(({data}) => {
          this[scope][index].options = data.community_building_list;
        });
      },
      /* 获取单元下拉 */
      unitSelect (index, cascadeParam = {}, scope = 'searchList') {
        this.$get({
          url: '/select_list/community_units_list',
          params: {
            community_id: cascadeParam.communityId,
            building_id: cascadeParam.buildingId,
            search: ''
          }
        }).then(({data}) => {
          this[scope][index].options = data.community_units_list;
        });
      },
      /* 获取房间下拉 */
      roomSelect (index, cascadeParam = {}, scope = 'searchList') {
        this.$get({
          url: '/select_list/community_room_list',
          params: {
            community_id: cascadeParam.communityId,
            building_id: cascadeParam.buildingId,
            units_id: cascadeParam.unitId
          }
        }).then(({data}) => {
          this[scope][index].options = data.community_room_list;
        });
      },

      /* 获取位置下拉 */
      positionSelect (index, cascadeParam = {}, scope = 'searchList') {
        this.$get({
          url: '/select_list/position_list',
          params: {
            community_id: cascadeParam.communityId,
            search: ''
          }
        }).then(({data}) => {
          this[scope][index].options = data.position_list;
        });
      },
      /* 获取设备下拉 */
      deviceSelect (index, cascadeParam = {}, scope = 'searchList') {
        this.$get({
          url: '/select_list/devices_list',
          params: {
            position_id: cascadeParam.position_id,
            search: ''
          }
        }).then(({data}) => {
          this[scope][index].options = data.devices_list;
        });
      },
      /* 获取产品分类 */
      categorySelect (index = 0, scope = 'searchList', level = 4) {
        this.$get({
          url: '/category/product/get_category_list',
          params: { level: level }
        }).then(({data}) => {
          this[scope][index].options = data;
        });
      },
      /* 小区change,联动位置列表 */
      communityChange_getPosi (index, val, scope) {
        this.cascadeParam.communityId = val;
        this.positionSelect(index, this.cascadeParam, scope);
      },
      /* 小区change,联动位置列表 */
      positionChange (index, val, scope) {
        this.cascadeParam.position_id = val;
        this.deviceSelect(index, this.cascadeParam, scope);
      },

      /* 小区change,联动楼栋列表 */
      communityChange (index, val, scope) {
        let resetKey = ['building_id', 'unit_id', 'room_id'];
        if (this.$refs.addEdit) {
          this.$refs.addEdit.resetSubValue(resetKey);
        } else {
          empty.$emit('resetForm', resetKey);
        }
        this.cascadeParam.communityId = val;
        this.buildSelect(index, this.cascadeParam, scope);
      },
      /* 楼栋change，联动单元列表 */
      buildingChange (index, val, scope) {
        let resetKey = ['unit_id', 'room_id'];
        if (this.$refs.addEdit) {
          this.$refs.addEdit.resetSubValue(resetKey);
        } else {
          empty.$emit('resetForm', resetKey);
        }
        this.cascadeParam.buildingId = val;
        this.unitSelect(index, this.cascadeParam, scope);
      },
      /* 单元change，联动房间列表 */
      unitChange (index, val, scope) {
        let resetKey = ['room_id'];
        if (this.$refs.addEdit) {
          this.$refs.addEdit.resetSubValue(resetKey);
        } else {
          empty.$emit('resetForm', resetKey);
        }
        this.cascadeParam.unitId = val;
        this.roomSelect(index, this.cascadeParam, scope);
      },

      /* 会员管理下拉（会员管理模块） */
      memberManageSelect (paramArr) {
        this.$get({
          url: '/select_list/member_manage_list',
          params: {}
        }).then(({data}) => {
          paramArr.forEach((ele) => {
            this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
          });
        });
      },
      /*  设备管理下拉（设备管理模块） */
      deviceManageSelect (paramArr, query) {
        this.$get({
          url: '/select_list/devices_manage_list',
          params: query
        }).then(({data}) => {
          paramArr.forEach((ele) => {
            this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
          });
        });
      },
      /*  物业管理下拉（物业管理模块） */
      propertyManageSelect (paramArr) {
        this.$get({
          url: '/select_list/property_manage_list',
          params: {}
        }).then(({data}) => {
          paramArr.forEach((ele) => {
            this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
          });
        });
      },
      /*  运营管理下拉（运营管理模块） */
      marketingManageSelect (param) {
        this.$get({
          url: '/select_list/operate_manage_list',
          params: {}
        }).then(({data}) => {
          if (param && typeof param === 'function') {
            param(data);
          } else {
            param.forEach((ele) => {
              this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
            });
          }
        });
      },
      /* 获取通用类别（晓纹接口） */
      typeSelect (params) {
        this.$get({
          url: '/get_typedesc',
          params: { type: params.query, format: params.format }
        }).then(({data}) => {
          if (params.handle && typeof params.handle === 'function') {
            params.handle(data);
          } else {
            this[params.scope || 'formList'][params.index].options = data;
          }
        });
      },
      /* 获取角色列表 */
      roleSelect (handle) {
        this.$get({
          url: '/get_roles_tree',
          params: {}
        }).then(({data}) => {
          if (typeof handle === 'function') {
            handle(data);
          }
        });
      }
    }
  },
  richText: {
    data () {
      return { editorVal: '' };
    },
    mounted () {
      this.initEditor();
    },
    methods: {
      /* 初始化富文本 */
      initEditor () {
        this.editor = new this.WangEditor('#editor');
        this.editor.customConfig = {
          debug: true,
          zIndex: 1,
          customUploadImg: this.customUploadImg,
          onchange: (html) => {
            if (html === '<p><br></p>') {
              this.editorVal = undefined;
            } else {
              this.editorVal = html;
            }
          }
        };
        this.editor.create();
      },
      /* 自定义上传图片 */
      customUploadImg (files, insert) {
        var formData = new FormData();
        files && files.forEach((el) => {
          formData.append('file[]', el);
        });
        this.$post({
          url: '/file/ht_multi_upload',
          params: formData
        }).then(({data}) => {
          data && data.forEach((el) => {
            insert(el.file_url);
          });
        });
      },

      /* 处理富文本图片 */
      handleImageAdded (file, Editor, cursorLocation, resetUploader) {
        var formData = new FormData();
        formData.set('file', file);
        this.$post({
          url: `/file/ht_upload`,
          params: formData
        }).then(({data}) => {
          let url = data.file_url;
          if (url) {
            Editor.insertEmbed(cursorLocation, 'image', url);
            resetUploader();
          }
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/mixins.js